import React, { useState } from "react";
import { EnquiryFormType } from "./types";
import EnquiryForm from "./Form";
import { submitEnquiry } from "@api/submitEnquiry";
import { Alert } from "react-bootstrap";

const suggestions = {
    title: ["Packages", "Availability", "Price Enquiry", "Quote"],
    descriptions: {
        "0": "Hi there, do you have any wedding packages you could send to us? Thanks!",
        "1": "Hello, I was wondering about your availability...",
        "2": "Hello, are you able to let me know your prices? Thank You!",
        "3": "Hi, we were wondering if we could get a quote for your services at our wedding please? Many thanks.",
        "0,1": "Hello! Would you be available for our wedding? We'd love to find out more about your packages. Thank you!",
        "0,2": "Hi! We'd like to find out more about what packages you offer. Could you please send us through some details about your packages and pricing? Thanks!",
        "0,3": "Hello! We'd like to find out more information. Would you be able to send through some info about what wedding packages you have and what you need for a quote? Thank you.",
        "1,2": "Hi, would you be available for our wedding? We'd like to know more about prices please. Thank you!",
        "1,3": "Hi! Are you available for our wedding date? We'd love to get a quote. Thanks!",
        "2,3": "Hi! Would you be able to send us a quote or some details about pricing please? Thank you!",
        "0,2,3":
            "Hi! We'd like to chat to you about our wedding. Could you please send me some details about your packages and pricing or quotes? Thank you!",
        "1,2,3":
            "Hi! I was wondering if you're available for our wedding? I'd be interested in finding out more about your quotes and pricing. Thank you.",
        "0,1,3":
            "Hi, we're interested to see whether you'd be available for our wedding. Would you be able to send through some details about your packages and quotes? Thanks!",
        "0,1,2":
            "Hi, would you be available for our wedding? We'd love to know more about your packages and prices. Thanks.",
        "0,1,2,3":
            "Hi! We've been looking at your services for our wedding. We'd love to find out more about your prices or quotes, as well as your availability and packages. Thank you so much!",
    },
};

export interface EnquiryFormContainerProps {
    supplierName: string;
    supplierId: number;
    categoryId: number;
    categorySlug: string;
    supplierRegionId: number;
    enquirySource: string;
    listenSpecialEventClick?: boolean;
    isSupplierMessaging?: boolean;
    hideGuest?: boolean;
    isFashionCategory?: boolean;
    onCompleted?: (userName: string, userEmail: string, userPhone: string, weddingDate: Date) => void;
}

function EnquiryFormContainer({ supplierName, supplierId, categoryId, categorySlug, supplierRegionId, enquirySource, listenSpecialEventClick = false, isSupplierMessaging = false, hideGuest = false, isFashionCategory = false, onCompleted }: EnquiryFormContainerProps) {
    const [message, setMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<string>("");

    // Show master venue for all categories except wedding venues, engagement venues and non fashion categories
    const showMasterVenue = !isFashionCategory && 
        categorySlug?.toLowerCase() !== 'weddingvenues' && 
        categorySlug?.toLowerCase() !== 'engagementvenues';
    const isEngagementVenue = (!!categorySlug && categorySlug.toLowerCase() === 'engagementvenues');

    const showMessage = (message: string, isError: boolean) => {
        setMessage(message);
        setAlertType(isError ? "danger" : "success");
        setTimeout(() => setMessage(''), 3000);
    }
    
    const onSubmit: (data: EnquiryFormType, masterVenueUpdated: boolean) => Promise<void> = async (data, masterVenueUpdated) => {
        const request = {
            "Name": data.name,
            "Phone": data.phone,
            "Email": data.email,
            "WeddingDate": data.date,
            "EngagementDate": data.engagementDate,
            "WeddingLocation": data.regionName,
            "Comment": data.message,
            "NumberOfGuests": data.guests,
            "SupplierEmail": "",
            "SupplierId": supplierId,
            "CategoryId": categoryId,
            "RegionId": supplierRegionId,
            "Brochure": false,
            "NominatedDates": "",
            "QAs": [],
            "Price": false,
            "Availability": false,
            "SupplierName": supplierName,
            "EnquiryType": 1,
            "IsLongForm": true,
            "CategorySlug": categorySlug,
            "IsPpa": false,
            "UserAgent": !!navigator?.userAgent ? navigator.userAgent : '',
            "EnquirySource": enquirySource,
            "BookedVenueSupplierID": masterVenueUpdated ? data.venueId : '',
            "BookedVenueSupplierName": masterVenueUpdated ? data.venueName : '',
        };

        try {
            const response = await submitEnquiry(data, JSON.stringify(request));
    
            if (!response) {
                showMessage("Enquiry failed", true);
            }
            else if (response.hasError) {
                showMessage(response.errorMessage, true);
            }
            else {
                showMessage("Enquiry sent successfully.", false);
                onCompleted?.(data.name, data.email, data.phone, data.date);
            }
        }
        catch (e) {
            console.error(e);
            showMessage("An error occurred. Please try again later.", true);
        }
    }

    return (<>
        <EnquiryForm
            key={supplierId}
            supplierName={supplierName}
            showMasterVenue={showMasterVenue}
            onSubmit={onSubmit}
            isSupplierMessaging={isSupplierMessaging}
            listenSpecialEventClick={listenSpecialEventClick}
            hideGuest={hideGuest}
            isEngagementVenue={isEngagementVenue}
            textOptions={{
                tags: suggestions.title,
                suggestions: suggestions.descriptions,
            }}
        />
        {!!message && <Alert variant={alertType}>{message}</Alert>}
    </>);
}

export default EnquiryFormContainer;
